import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['toggleable', 'disableable'];
  static values = {
    open: Boolean,
    toggleClass: String
  };

  connect() {
    // prefer the new Stimulus value if present,
    if (this.hasToggleClassValue) {
      this.toggleClass = this.toggleClassValue;
    } else {
      // otherwise fall back to the legacy data-class attr or "hidden"
      // Once all instances use the new toggleClassValue, we can remove this fallback
      this.toggleClass = this.data.get('class') || 'hidden';
    }
  }

  toggle(event) {
    if (event.target.getAttribute('type') != 'checkbox') {
      event.preventDefault();
    }
    this.openValue = !this.openValue;
  }

  hide(event) {
    event.preventDefault();

    this.openValue = false;
  }

  show(event) {
    event.preventDefault();

    this.openValue = true;
  }

  openValueChanged() {
    if (!this.toggleClass) {
      return;
    }

    this.toggleableTargets.forEach(target => {
      // if the element has its own data-toggle-class, use that:
      const cls = target.dataset.toggleClass || this.toggleClass;
      target.classList.toggle(cls);
    });

    this.disableableTargets.forEach(target => {
      if (target.tomselect !== undefined) {
        this.toggleTomSelect(target);
      } else {
        target.disabled = !target.disabled;
      }
    });
  }

  toggleTomSelect(target) {
    target.tomselect.isDisabled ? target.tomselect.enable() : target.tomselect.disable();
  }
}
